import React, { useState } from 'react'

export default function Preview({ url, type }) {
    const [IsShowing, setIsShowing] = useState(false)

    function handleClose() {
        setIsShowing(false)
    }

    return (
        <>
            {type === "photo" && <img src={url} alt="Media View" height="70" onClick={() => setIsShowing(true)} style={{ cursor: 'pointer', marginRight: 5 }} />}
            {type === "video" && <video src={url} alt="Media View" height="70" onClick={() => setIsShowing(true)} style={{ cursor: 'pointer' }} />}
            {IsShowing && <div className={`modal fade show`} id="modal-default" style={{ display: 'block', paddingRight: 17 }} aria-modal="true" role="dialog">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"></h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => handleClose()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '83vh', overflowY: 'auto' }}>
                            {type === "photo" && <img src={url} alt="Media View" style={{ width: '100%' }} />}
                            {type === "video" && <video src={url} style={{ width: '100%' }} controls />}
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}
